import {
    Button, Table, TableBody, TableCell, TableContainer,
    TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Box,
    DialogContentText, TableHead
} from '@mui/material';
import PriceSummary from '../../components/appointments/priceSummery'; // <-- Import the corrected component

// Confirmation Dialog Component
const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    pendingSubmission,
    scansList,
    branches, // <-- Make sure to pass branches to this dialog
    t
}) => {
    if (!pendingSubmission) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('appointments.confirmAppointment')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('appointments.reviewAppointmentDetails')}:
                </DialogContentText>
                <Box sx={{ mt: 2 }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell><b>{t('appointments.patient')}</b></TableCell>
                                    <TableCell>{pendingSubmission.patient?.name}</TableCell>
                                </TableRow>
                                {pendingSubmission.radiologist &&
                                    <TableRow>
                                        <TableCell><b>{t('appointments.radiologist')}</b></TableCell>
                                        <TableCell>{pendingSubmission.radiologist?.name}</TableCell>
                                    </TableRow>
                                }
                                {pendingSubmission.technician && <TableRow>
                                    <TableCell><b>{t('appointments.technician')}</b></TableCell>
                                    <TableCell>{pendingSubmission.technician?.name}</TableCell>
                                </TableRow>
                                }
                                <TableRow>
                                    <TableCell><b>{t('appointments.branch')}</b></TableCell>
                                    <TableCell>{pendingSubmission.branchObj?.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><b>{t('appointments.date')}</b></TableCell>
                                    <TableCell>{pendingSubmission.scheduledDate?.toLocaleDateString()}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><b>{t('appointments.time')}</b></TableCell>
                                    <TableCell>{pendingSubmission.scheduledTime?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* ==================================================================== */}
                    {/*              FIX: Use the PriceSummary Component Here              */}
                    {/* ==================================================================== */}
                    <Box mt={2}>
                        <PriceSummary
                            basePrice={pendingSubmission.basePrice}
                            discountAmount={pendingSubmission.discountAmount}
                            completionFee={pendingSubmission.completionFee}
                            customPrice={pendingSubmission.customPrice}
                            makeHugeSale={pendingSubmission.makeHugeSale}
                            selectedBranch={pendingSubmission.branch}
                            branches={branches}
                            selectedScans={pendingSubmission.scans}
                            scansList={scansList}
                            t={t}
                        />
                    </Box>
                    {/* ==================================================================== */}

                    {pendingSubmission.notes && (
                        <TableContainer component={Paper}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><b>{t('common.notes')}</b></TableCell>
                                        <TableCell align="right">{pendingSubmission.notes}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}

                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">{t('common.edit')}</Button>
                <Button onClick={onConfirm} color="primary" variant="contained">{t('appointments.confirmAndSend')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;